"use client";

import {
  IStoryBlokComponent,
  IStoryBlokCta,
} from "apps/website/components/page/api.types";
import { getStoryBlokCta } from "apps/website/utils/storyblok/links";
import { renderStoryBlokRichText } from "apps/website/utils/storyblok/text";
import { IconSvg } from "apps/website/components/base/Icon/Icon.map";

import SectionOurPromise from "../../section/SectionOurPromise/SectionOurPromise";

export interface IStoryBlokOurPromiseItem {
  _uid: string;
  icon: IconSvg;
  title: string;
  body: string;
}

export interface IStoryBlokOurPromise {
  _uid: string;
  component: "section_our_promise";
  title?: string;
  items?: IStoryBlokOurPromiseItem[];
  cta?: IStoryBlokCta[];
}

export const StoryBlokOurPromise = ({ blok }: IStoryBlokComponent<IStoryBlokOurPromise>) => {
  const cta = blok.cta?.[0];
  const ctaLink = cta ? getStoryBlokCta(cta) : undefined;

  const hasItems = blok.items && blok.items.length > 0;

  return (
    <SectionOurPromise
      title={blok.title || undefined}
      items={hasItems ? blok.items?.map((item) => ({
        icon: item.icon,
        title: item.title,
        body: renderStoryBlokRichText(item.body),
      })) : undefined}
      ctaText={cta?.name || undefined}
      ctaHref={ctaLink?.to || undefined}
    />
  );
};
